module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoBdIt.76f5ed5b.otf";